import { sendUtagEvent } from '../../core/analytics/utag_events'
import { getCleanedString } from '../../utils/utilities'

export function sendHeadbandUtagEvent(headband) {
  const event_cat = getCleanedString(headband.dataset.eventCat)
  const event_act = getCleanedString((headband.dataset.eventAct || '').toLowerCase())
  let event_lbl = ''
  if (event_act === 'promo code') {
    event_lbl = getCleanedString(headband.querySelector('.js-promolink').dataset.promocode)
  } else {
    event_lbl = getCleanedString(headband.dataset.eventLbl)
  }
  sendUtagEvent({
    data: {
      event_name: 'offers_apply',
      event_cat: 'offers',
      event_act: 'apply offer',
      event_lbl,
      event_purpose: 'booking',
      event_structure: 'sticky',
    },
  })

  sendUtagEvent({
    data: {
      event_name: 'headband_module',
      event_cat,
      event_act,
      event_lbl,
      event_purpose: 'information',
      event_structure: 'sticky',
    },
  })
}

export function sendFastbookingHeadbandUtagEvent(eventLbl, eventStructure) {
  sendUtagEvent({
    data: {
      event_name: 'searcher_hotel',
      event_cat: 'searcher',
      event_act: 'scroll to fastbooking',
      event_lbl: eventLbl,
      event_purpose: 'booking',
      event_structure: eventStructure,
    },
  })
}
